import { useRef, useState } from 'react';

import { useEffectOnce, useViewport } from '@/hooks';

/**
 * BuildAiModal의 상태를 관리하는 hook
 *
 * 책임:
 * - shouldShowSimple 상태 관리 (모바일 simple mode)
 * - isInitialized ref 관리 (초기화 상태)
 * - 생성 성공 시 모바일 simple mode 전환
 * - Full prompt mode 복원
 *
 * @returns Modal 상태와 상태 변경 함수들
 */
export const useAiModalState = () => {
  const { isPortable } = useViewport();
  const [shouldShowSimple, setShouldShowSimple] = useState(false);
  const isInitialized = useRef<boolean>(false);

  useEffectOnce(() => {
    isInitialized.current = true;
  });

  /**
   * 생성 성공 시 호출
   * 모바일 환경에서만 simple mode로 전환
   */
  const handleGenerationSuccess = () => {
    if (isPortable) setShouldShowSimple(true);
  };

  /**
   * Full prompt mode로 복원
   */
  const showFullPrompt = () => setShouldShowSimple(false);

  return {
    shouldShowSimple,
    isInitialized: isInitialized.current,
    handleGenerationSuccess,
    showFullPrompt,
  };
};
